import axios from "axios";

export const getAPIUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        return `${process.env.REACT_APP_API_URL}`;
    }
    return `${window.location.protocol}//${window.location.hostname}/api/v1_0`;
};



export const getAnalyzeAPIUrl = getAPIUrl;

export const getAnalyzeActAPIUrl = () => {
    return `${window.location.protocol}//${window.location.hostname}/api/v1_0`;
}

export const getAuthAPIUrl = () => {
    if (process.env.REACT_APP_AUTH_API_URL) {
        return `${process.env.REACT_APP_AUTH_API_URL}`;
    }
    return `${window.location.protocol}//${window.location.hostname}/api/v1_0`;
}

export const getList = async (sectionName) => {
    try {
        const res = await axios.get(`${getAPIUrl()}/${sectionName}`);
        return res;
    } catch (error) {
        console.error(`Ошибка при получении данных для раздела ${sectionName}:`, error);
        throw error; // Передаем ошибку дальше для обработки в компоненте
    }
};


export const getStoredVKUsers = async (userIds) => {
    try {
        const params = new URLSearchParams();
        userIds.forEach(id => params.append('user_ids', id));
        
        const res = await axios.get(`${getAPIUrl()}/vk/get_data_users/stored?${params.toString()}`);
        return res.data;
    } catch (error) {
        console.error('Ошибка при получении сохраненных данных пользователей VK:', error);
        throw error;
    }
};

